export class Constants {

  // local storage keys
  public static readonly LOCAL_STORAGE_SELECTED_SERVICE_KEY = 'selectedService';

  // main components
  public static readonly LOGIN_PATH = "login";
  public static readonly SELECT_SERVICE_PATH = "select-service";
  public static readonly DASHBOARD_PATH = "dashboard";
  public static readonly CHECK_USAGE_PATH = "check-usage";
  public static readonly MY_PLAN_PATH = "my-plan";
  public static readonly VIEW_CONX_HISTORY_PATH = "view-connection-history";
  public static readonly MOVING_HOME_PATH = "moving-home";
  public static readonly CONFIRM_MOVING_HOME_PATH = "confirm-moving-home";
  public static readonly MANAGE_MAILBOX_PATH = "manage-mailbox";
  public static readonly ABOUT_ME_PATH = "about-me";
  public static readonly INVOICE_PATH = "invoices";
  public static readonly PAYMENT_DETAILS_PATH = "payment-details";
  public static readonly NOTIFICATIONS_PATH = "notifications";
  public static readonly SETTINGS_PATH = "settings";
  public static readonly PROMO_CODE_PATH = "promo-code";
  public static readonly ADD_FETCH = "add-fetch";
  public static readonly ADD_FETCH_MULTIROOM_PATH = "add-fetch-multiroom";
  public static readonly MANAGE_CALL_PACKS_PATH = "manage-call-packs";
  public static readonly MANAGE_PREPAID_BALANCE = "top-up-prepaid-balance";
  public static readonly SHOW_PUK_CODE = "puk-code";
  public static readonly CANCEL_FETCH_SERVICE = "cancel-fetch-service";
  public static readonly ADD_NEW_SERVICE = 'add-new-service';
  public static readonly LINK_ACCOUNT = 'link-account';
  public static readonly HOME_WIRELESS_UPGRADE = "save-with-home-wireless";
  public static readonly SETUP_PAYMENT_PLAN = "setup-payment-plan";
  public static readonly MANAGE_INTERNET_PACK_PATH = "manage-internet-pack";
  public static readonly NEW_STATIC_IP_PATH = "new-static-ip";
  // dashboard child components
  public static readonly ACTIVATE_SIM_PATH = "activate-sim";
  public static readonly ADD_PREPAID_BALANCE_PATH = "add-prepaid-balance";
  // about me child components
  public static readonly CHANGE_PASSWORD_PATH = "change-password";
  public static readonly CHANGE_PASSWORD_SUCCESS_PATH = "change-password-success";
  public static readonly EDIT_DETAILS_SUCCESS_PATH = "edit-details-success";
  // manage mailbox child components
  public static readonly ADD_MAILBOX_PATH = "add-mailbox";
  public static readonly REMOVE_MAILBOX_PATH = "remove-mailbox";
  public static readonly MAILBOX_SETTINGS_PATH = "mailbox-settings";
  // invoice child components
  public static readonly ADD_CREDIT_PATH = "add-credit";
  // my plan child components
  public static readonly CHANGE_PLAN_PATH = "change";
  public static readonly PLAN_CONFIRMATION_PATH = "plan-confirmation";
  // check-usage child components
  public static readonly PURCHASE_DATA_PACKS_PATH = "purchase-data-packs";
  public static readonly CONFIRM_DATA_PACK_SELECTION_PATH = "confirm-data-pack-selection";
  // add fetch multiroom child components
  public static readonly ADD_FETCH_CONFIRM_ADDRESS_PATH = "add-fetch-confirm-address-path";
  public static readonly ADD_FETCH_CONFIRM_ORDER_PATH = "add-fetch-confirm-order-path";
  // manage call packs child components
  public static readonly CONFIRM_MANAGE_CALL_PACK_PATH = "confirm-phone-plan-changes";
  public static readonly CONFIRM_TURBOFIBRE_MANAGE_CALL_PACK_PATH = "confirm-turbofibre-phone-plan-changes";
  public static readonly CONFIRM_MOBILE_MANAGE_CALL_PACK_PATH = "confirm-mobile-phone-plan-changes";
  // settings child components
  public static readonly CANCEL_ORDER = "cancel-order";
  public static readonly CANCEL_SERVICE = "cancel-service";
  // prepaid balance child
  public static readonly ADD_PREPAID = "add-prepaid";
  // setup payment plan child components
  public static readonly CONFIRM_PAYMENT_PLAN = "confirm-payment-plan";
  // manage internet pack child components
  public static readonly CONFIRM_INTERNET_PACK_PATH = "confirm-internet-pack";

  public static readonly FIBRE_CONNECT_PATH = "fibre-connect-upgrade";
  public static readonly ESIM_SWAP_PATH = "esim-swap";
  public static readonly ESIM_SWAP_SESSION_DETAILS = "ESIM_SWAP_SESSION_DETAILS";
  public static readonly ESIM_SWAP_OTP_SESSION_TIMEOUT_MINUTES = 15;
  public static readonly  ESIM_SWAP_AUTH_SESSION_EXPIRED = "AUTH_SESSION_EXPIRED";
  public static readonly  ESIM_SWAP_SESSION_EXPIRED = "SESSION_EXPIRED";
  public static readonly  ESIM_SWAP_INITIATED = "INITIATED";
  public static readonly  BONUS_INTERNATIONAL_CALLS_PATH = "bonus-international-calls";

  public static readonly REDIRECT_TO_PARENT_URLS: string[] = [Constants.MANAGE_MAILBOX_PATH];
  public static readonly NEED_SERVICE_SELECTION_URLS: string[] = [
    Constants.DASHBOARD_PATH,
    Constants.MY_PLAN_PATH,
    Constants.CHECK_USAGE_PATH,
    Constants.BONUS_INTERNATIONAL_CALLS_PATH,
    Constants.VIEW_CONX_HISTORY_PATH,
    Constants.MOVING_HOME_PATH,
    Constants.SETTINGS_PATH,
    Constants.ADD_FETCH_MULTIROOM_PATH,
    Constants.MANAGE_CALL_PACKS_PATH,
    Constants.FIBRE_CONNECT_PATH,
    Constants.ESIM_SWAP_PATH];


  //date formats
  public static readonly MOMENT_DAY_MONTH_YEAR_FORMAT = {
    parse: {
      dateInput: 'DD/MM/YYYY',
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };

  // UTC+10:00
  public static readonly AEST_TIMEZONE_VALUE = "+1000";

  // UTC +11:00
  public static readonly AEDT_TIMEZONE_VALUE = '+1100';

  public static readonly SUPER_ULTRA_FAST_ACCC_NAMES = ["homeultrafast", "homesuperfast", "nbnsuperfast", "nbnultrafast", "nbn250", "nbn1000"];
  public static readonly FOF_ELIGIBLE_TECHNOLOGIES = ["fibre", "fttp", "nfas", "hfc", "nhas"];

  //data usage types
  public static readonly PEAK_OFFPEAK = "peak_offPeak";
  public static readonly QUOTA = "quota";
  public static readonly UNLIMITED = "unlimited";

  //iinet icon file
  public static readonly IINET_ICON_PATH = 'assets/iinet-icons.svg';

  // BRANDS
  public static readonly BRAND_IINET = 'iiNet';
  public static readonly BRAND_INTERNODE = 'Internode';
  public static readonly BRAND_WESTNET = "Westnet";
  public static readonly BRAND_TPG = "TPG";

  // tooltip messages
  public static readonly MULTIPLE_FIELDS_TOOLTIP = "Please complete all of the required fields.";
  public static readonly AGREE_TO_TERMS_TOOLTIP = "Please confirm you agree to the terms above.";
  public static readonly SELECT_OPTION_TOOLTIP = "Select an option above.";
  public static readonly MAKE_PAYMENT_TOOLTIP = "Please enter a valid amount.";
  public static readonly PLAN_UNSUPPORTED_TOOLTIP = "Your NBN line speed does not support this plan";

  // form validations
  public static readonly EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public static readonly PASSWORD_MISMATCH_ERROR = 'The passwords you entered did not match.';
  public static readonly CONFIRM_PASSWORD_EMPTY_ERROR = 'Please confirm your password.';
  public static readonly EMAIL_REQUIRED_ERROR = 'Email is required.';
  public static readonly EMAIL_UNIQUE_ERROR = 'Email should be unique.';
  public static readonly EMAIL_FORMAT_ERROR = "A valid email address is required. Eg. john@gmail.com.";
  public static readonly PHONE_FORMAT_ERROR = "Phone number must be exactly 10 digits, beginning with 02, 03, 04, 07, 08 or 09.";
  public static readonly MOBILE_FORMAT_ERROR = "Mobile number must be exactly 10 digits, beginning with 04 or 09.";
  public static readonly CONTACT_TYPE_REQUIRED_ERROR = "Contact Type is required.";
  public static readonly DATE_OF_BIRTH_REQUIRED_ERROR = "Date of birth is required.";
  public static readonly DATE_OF_BIRTH_MAX_ERROR = "Please enter a valid Date of Birth value.";
  public static readonly DATE_OF_BIRTH_MIN_AGE_ERROR = "You must be over 18 years of age to sign up.";
  public static readonly DATE_OF_BIRTH_MAX_AGE_ERROR = "You must be less than 100 years of age to sign up.";
  public static readonly DATE_OF_BIRTH_YEAR_ERROR = "Please enter a valid Date of Birth value.";

  public static readonly ADDITIONAL_CONTACT_TECHNICAL = 'Technical';
  public static readonly ADDITIONAL_CONTACT_BILLING = 'Billing';
  public static readonly ADDITIONAL_CONTACT_TYPES = [Constants.ADDITIONAL_CONTACT_TECHNICAL, Constants.ADDITIONAL_CONTACT_BILLING];

  public static readonly SERVER_ERROR = "Something has gone wrong. You will be redirected to the homepage. Please try again later.";

  public static readonly EDIT_USER_DETAILS = 'editUserDetails';
  public static readonly EDIT_ADDL_CONTACT_DETAILS = 'editAddlContactDetails';
  public static readonly ADD_ADDL_CONTACT_DETAILS = 'addAddlContactDetails';
  public static readonly REMOVE_ADDL_CONTACT_DETAILS = 'removeAddlContactDetails';

  public static readonly ACTION_ADD_MOBILE_INTERNATIONAL_CALLPACK = "mod-vha-mobile-add-international-call-pack"
  public static readonly ACTION_REMOVE_MOBILE_INTERNATIONAL_CALLPACK = "mod-vha-mobile-remove-international-call-pack"

  public static readonly TWO_DAYS_IN_MINUTES = 2880;

  public static readonly CHANGE_PLAN_TRANSACTION = "COP";
  public static readonly PROMO_CODE_TRANSACTION = "Add Promo";

  // HTTP Codes
  public static readonly TOO_MANY_ATTEMPTS = 429;

  // Modem Compatibility
  public static readonly FULLY_SUPPORTED = ["TP-Link VX220-G2V", "TP-Link VX420-G2H", "TP-Link VX420-G2V", "Arcadyan HWG2025"];
}
